import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeArr } from '@/shared/functions';
const initState = {
    cardInfoList: [],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 加载数据 */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                Api.finance.selectAccountSumList().then((res) => {
                    console.log('selectAccountSumList res', res);
                    if (judgeArr(res)) {
                        this.SET_STATE({
                            cardInfoList: res,
                        });
                    }
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
    },
});
